import { Link } from 'react-router-dom';

export default function FAQSection() {
  const faqs = [
    { q: '这个网站需要注册才能使用吗？', a: '完全不需要注册！所有链接均可直接访问，无需任何注册或登录步骤，打开即用。' },
    { q: '网站上的资源链接多久更新一次？', a: '我们每天都会对收录的福利视频网址进行检查和更新，确保链接有效性。' },
    { q: '收录的资源是否都是免费高清的？', a: '我们严格筛选收录的资源，优先推荐免费且支持高清播放的视频内容。' },
    { q: '如何在手机端使用这个导航网站？', a: '网站采用响应式设计，完美适配手机、平板和电脑等各种设备。' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">快速了解福利视频网址大全的使用方式</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/about"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
          >
            了解更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}